import styled from '@emotion/styled'

export const StyledChargesBlock = styled.div`
  padding: 36px 24px;
  background-color: var(--White97);
`
